module.exports = __webpack_public_path__ + "img/case-logo-46.31cb0d0b.png";